import * as React from 'react';

function SvgSe(props) {
  return (
    <svg width={24} height={24} fill="#fff" viewBox="-50 0 466 466" {...props}>
      <path d="M0 66.57C0 29.96 29.98 0 66.62 0h266.47c8.75 0 17.42 1.72 25.5 5.07 8.08 3.34 15.42 8.25 21.61 14.43s11.09 13.52 14.44 21.6a66.444 66.444 0 015.07 25.47zM399.71 299.57H0c0 36.62 29.98 66.57 66.62 66.57h166.55V466l99.92-99.86c8.75 0 17.42-1.72 25.5-5.06a66.644 66.644 0 0021.61-14.44 66.56 66.56 0 0014.44-21.59 66.531 66.531 0 005.07-25.48zM0 99.86h399.71v66.57H0zM0 199.71h399.71v66.58H0z" />
    </svg>
  );
}

export default SvgSe;
